import "./results.css";

/* One number per pillar of the "What you get" list, ordered by how much of
   the week each one gives back: the tracker running off your weekly plan,
   interview prep, networking, then the resume reviewer.

   `tone` is positional — blue, violet, teal, coral left to right, the page's
   accent order — so reordering the stats does not reshuffle the colours. */
const stats = [
  {
    tone: "blue",
    value: "5 hrs",
    label: "saved each week on tracking and follow-ups.",
  },
  {
    tone: "violet",
    value: "3x",
    label: "more practice interviews before the first round.",
  },
  {
    tone: "teal",
    value: "6+",
    label: "networking calls each month.",
  },
  {
    tone: "coral",
    value: "10%",
    label: "higher resume scores after one review.",
  },
];

const Results = () => (
  <section className="s-section">
    <div className="home-container">
      <div className="s-results-head">
        {/* "Results", not "Proven results", until the footnote below can
            name a real survey. */}
        <span className="s-eyebrow">Results</span>
        <h2 className="home-section-title s-results-title">
          Less guesswork. More momentum.
        </h2>
      </div>

      <dl className="s-results-row">
        {stats.map(({ tone, value, label }) => (
          <div className={`s-stat s-stat-${tone}`} key={value}>
            <span className="s-stat-rule" aria-hidden="true" />
            <dt className="s-stat-value">{value}</dt>
            <dd className="s-stat-label">{label}</dd>
          </div>
        ))}
      </dl>

      {/* The term, the year and the sample size used to sit here as bracketed
          placeholders and went live that way. They are out until the survey
          they refer to exists; when it does, add them back to this line as
          "Self-reported by RAIN students, Spring 2026 (n=###)". Do not put
          brackets on the page again. */}
      <p className="s-results-foot">
        Self-reported by RAIN students, compared with their habits before RAIN.
      </p>
    </div>
  </section>
);

export default Results;
